import { useLang } from 'hooks/lang';

import { Alert } from 'components/Blocks';

export function CancelationRequested(): JSX.Element {
  const { t } = useLang();

  return (
    <Alert level="warning" title={t('cancelation-requested')}>
      {t('cancelation-requested-no-action')}
    </Alert>
  );
}
